import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/swiper-bundle.css";
import '../styles/ImageSlider.css';

import egov from '../ImageSliderAssets/egov.jpg';
import ramizder from '../ImageSliderAssets/ramizder.jpg';
import kitapkz from '../ImageSliderAssets/kitapkz.png';
import akordakz from '../ImageSliderAssets/akordakz.png';
import enbekkz from '../ImageSliderAssets/enbekkz.png';
import nabrk from '../ImageSliderAssets/nabrk.png';
import litPortal from '../ImageSliderAssets/adebietportaly.png';
import polpred from '../ImageSliderAssets/polpred.png';
import biblioclub from '../ImageSliderAssets/universitylibrary.png';
import artPortal from '../ImageSliderAssets/artportal.png';
import svidpovedy from '../ImageSliderAssets/svidpobedy.jpg';
import tehnodomImg from '../ImageSliderAssets/tehnodom.png';
import delnet from '../ImageSliderAssets/delnet.jpg';
import kazneb from '../ImageSliderAssets/kazneb.jpg';

const ImageSlider = () => {
    const images = [
        { id: 1, src: egov, alt: 'Еgov.kz', url: 'https://egov.kz/cms/kk' },
        { id: 2, src: ramizder, alt: 'Рәміздер', url: 'https://www.akorda.kz/kz/state_symbols/about_state_symbols' },
        { id: 3, src: kitapkz, alt: 'KITAP.KZ', url: 'https://kitap.kz/' },
        { id: 4, src: akordakz, alt: 'Akorda', url: 'https://www.akorda.kz/kz' },
        { id: 5, src: enbekkz, alt: 'Enbek.kz', url: 'https://www.enbek.kz/kk' },
        { id: 6, src: nabrk, alt: 'ҚР Ұлттық академиялық кітапханасы', url: 'https://nabrk.kz/kk' },
        { id: 7, src: litPortal, alt: 'Литературный портал', url: 'https://adebiportal.kz/kz' },
        { id: 8, src: polpred, alt: 'Polpred', url: 'https://polpred.com/' },
        { id: 9, src: biblioclub, alt: 'Университетская библиотека', url: 'https://biblioclub.ru/index.php?page=book_blocks&view=main_ub' },
        { id: 10, src: artPortal, alt: 'ART Portal', url: 'https://art.biblioclub.ru/' },
        { id: 11, src: svidpovedy, alt: 'Библиотеки свидетели победы', url: 'https://victory.libfl.ru/ru/home' },
        { id: 12, src: tehnodomImg, alt: 'Technodom', url: 'https://www.technodom.kz/almaty_kk?utm_source=google&utm_medium=cpc&utm_campaign=23885931117&gad_source=1&gad_campaignid=23895669103&gbraid=0AAAAAoZDuY-0m3bYIiN4ktCIY1IDE44bk&gclid=Cj0KCQjwrs7RBhDuARIsAIVfBD2enMEurhbRbyc56eu5539OXgqVX9NRZAr_nZVbBvMYWRSaNZkS_FAaAozxEALw_wcB' },
        { id: 13, src: delnet, alt: 'DELNET', url: 'https://delnet.in/index.html' },
        { id: 14, src: kazneb, alt: 'Kaznэб', url: 'https://kazneb.kz/kk/node' }
    ];

    const handleImageClick = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="slider-container">
            <div className="slider-wrapper">
                <Swiper
                    className="swiper"
                    modules={[Autoplay]}
                    spaceBetween={20}
                    slidesPerView={5}
                    slidesPerGroup={1}
                    loop={images.length > 5}
                    grabCursor={true}
                    autoplay={{
                        delay: 1000,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        // Когда ширина окна <= 320px
                        320: {
                            slidesPerView: 2,
                            slidesPerGroup: 1,
                            spaceBetween: 10,
                        },
                        // Когда ширина окна <= 480px
                        480: {
                            slidesPerView: 3,
                            slidesPerGroup: 1,
                            spaceBetween: 10,
                        },
                        // Когда ширина окна <= 768px
                        768: {
                            slidesPerView: 3,
                            slidesPerGroup: 1,
                            spaceBetween: 15,
                        },
                        // Когда ширина окна <= 992px
                        992: {
                            slidesPerView: 4,
                            slidesPerGroup: 1,
                            spaceBetween: 15,
                        },
                        // Когда ширина окна > 992px
                        993: {
                            slidesPerView: 5,
                            slidesPerGroup: 1,
                            spaceBetween: 20,
                        },
                    }}
                >
                    {images.map((image, index) => (
                        <SwiperSlide key={image.id}>
                            <div className="slide">
                                <img
                                    src={image.src}
                                    alt={image.alt}
                                    className="slide-image"
                                    onClick={() => handleImageClick(image.url)}
                                    style={{ cursor: 'pointer' }}
                                    title={`Перейти на ${image.alt}`}
                                />
                                <div className="slide-overlay"></div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default ImageSlider;